import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Button, TextField } from "@mui/material";

import request from "graphql-request";
import BASEURL from "../Utils/Baseurl";
import {
  createMonthlyTarget,
  createSalestargetdetails,
  salesRolesUsers,
  salesTargetDetailsById,
} from "./grphql";
import { useLoading } from "../../context/LodingContext";
import MaterialButton from "../../components/MaterialButton";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { useSuccess } from "../../context/SucccessContext";
import { useError } from "../../context/ErrorContext";
import { useNavigate } from "react-router-dom";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useLocation } from "react-router-dom";

const SinglePersonTarget = () => {
  const [monthTarget, setMonthTarget] = useState([
    {
      month: "January",
    },
    {
      month: "Feb",
    },
    {
      month: "March",
    },
    {
      month: "April",
    },
    {
      month: "May",
    },
    {
      month: "June",
    },
    {
      month: "July",
    },
    {
      month: "June",
    },
    {
      month: "June",
    },
    {
      month: "June",
    },
    {
      month: "June",
    },
  ]);
  const [dummyData, setDummyData] = useState(null);
  const [dummyMonths, setDummyMonths] = useState([]);
  const [originalMonths, setOriginalMonths] = useState([]);
  const [editIdx, setEditIdx] = useState(-1);
  const [totalTarget, setTotaltarget] = useState(0);
  const { circleLoading, setCirleLoading } = useLoading();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus } = useError();
  const [balanceAmount, setBalanceAmount] = useState(0);

  const handleSave = () => {
    setEditIdx(-1);
  };
  const [id, setId] = useState(null);

  const location = useLocation();

  const pathid = location.search.slice(1);
  useEffect(() => {
    fetchdata();
    setId(pathid);
  }, [pathid, id]);
  useEffect(() => {
    const monthData = dummyMonths?.map((v) => ({
      monthYear: v,
      targetAmount: "",
    }));
    setOriginalMonths(monthData);
  }, [dummyMonths]);

  useEffect(() => {
    const finalAmount = originalMonths?.reduce((acc, cur) => {
      return acc + Number(cur?.targetAmount);
    }, 0);

    setTotaltarget(Math.round(finalAmount));
  }, [originalMonths]);

  const fetchdata = async () => {
    try {
      const res = await request(BASEURL, salesTargetDetailsById, { id: id });

      setDummyData(res?.salesTargetDetailsById);
      setDummyMonths(res?.salesTargetDetailsById?.salesTarget?.months);
    } catch (err) {
    } finally {
    }
  };
     useEffect(() => {
      const allocatedAmount = originalMonths?.reduce((acc, cur) => acc + Number(cur?.targetAmount || 0), 0);
      const totalAmount = dummyData?.targetAmount || 0;
      const balance = totalAmount - allocatedAmount;
    
      setBalanceAmount(balance);
      }, [originalMonths, dummyData]);
  const handleEdit = (index) => {
    setEditIdx(index);
  };
  const handleChange = (e, index, field) => {
    const updatedData = [...originalMonths];
    // const newUpdateData = [...data];
    updatedData[index][field] = e.target.value;
    // const Entervalue = (newUpdateData[index][field] = e.target.value);
    // const divedvalue = data?.length - 1;
    // const blanceValue = targetValue - Entervalue;
    // const dividevalue = blanceValue / divedvalue;
    // updatedData.forEach((v, i) => {
    //   if (i == index) {
    //     v.targetAmount = Entervalue;
    //   } else {
    //     v.targetAmount = dividevalue;
    //   }
    // });
    // const totalamount2 = updatedData?.reduce(
    //   (acc, cur) => acc + Number(cur?.targetAmount),
    //   0
    // );
    setOriginalMonths(updatedData);
  };

  const handleMonthlyDistbute = () => {
    const amount = dummyData?.targetAmount / 12;


    const setamount = originalMonths?.map((v, i) => ({
      ...v,
      targetAmount: amount.toFixed(2),
    }));
    setOriginalMonths(setamount);
  };

  const handleMonthlysent = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, createMonthlyTarget, {
        input: {
          salesTargetnumId: id,
          monthlyTargets: originalMonths,
        },
      });
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <table className="montable">
        <thead>
          <tr className="montr">
            <th className="month">Employee Name</th>
            <th className="month">Finacial Year</th>
            <th className="month">Target Amount</th>
          </tr>
        </thead>
        <tbody className="month">
          <tr className="montr">
            <td className="montd">{dummyData?.name}</td>
            <td className="montd">{dummyData?.salesTarget?.financialYear}</td>
            <td className="montd">{dummyData?.targetAmount}</td>
          </tr>
        </tbody>
      </table>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          paddingRight: "20px",
          margin: "5px 0px",
        }}
      >
        <MaterialButton
          variant="gradient"
          color="dark"
          // disabled={totalTarget == totalamount ? false : true}
          // disabled={!checkAllFields()}
          onClick={handleMonthlyDistbute}
        >
          Distribute Evenly
        </MaterialButton>
      </div>

      <div className="tabel-target">
        <table>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Month</th>
              <th>Target Amount</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {originalMonths?.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{row.monthYear}</td>
                  <td
                    style={{
                      display: "flex",
                      marginTop: "5px",
                      alignItems: "center",
                    }}
                  >
                    {editIdx === index ? (
                      <TextField
                        type="number"
                        value={row.targetAmount}
                        onChange={(e) => handleChange(e, index, "targetAmount")}
                      />
                    ) : (
                      row.targetAmount || 0
                    )}

                    <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
                  </td>
                  <td>
                    {editIdx === index ? (
                      <Button onClick={handleSave}>Save</Button>
                    ) : (
                      <Button onClick={() => handleEdit(index)}>Edit</Button>
                    )}
                  </td>
                </tr>
              );
            })}
            <tr>
              <td></td>
              <td>Balance Amount</td>
              <td
              style={{
                display: "flex",
                marginTop: "4px",
                marginBottom: "4px",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "18px",
              }}>
                { balanceAmount.toFixed(0) }{" "}
              <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} /></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Total Amount </td>
              <td
                style={{
                  display: "flex",
                  marginTop: "15px",
                  alignItems: "center",
                  fontWeight: "600",
                  fontSize: "18px",
                }}
              >
                {dummyData?.targetAmount|| "0"}{" "}
                <CurrencyRupeeIcon sx={{ marginLeft: "10px" }} />
              </td>
              <td>
                {" "}
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  disabled={
                    totalTarget == dummyData?.targetAmount ? false : true
                  }
                  onClick={handleMonthlysent}
                >
                  Submit
                </MaterialButton>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default SinglePersonTarget;
